module.exports = __webpack_public_path__ + "img/element-button.fbaa886.svg";